import React, { useEffect, useState } from "react";
import AppointmentsService from "./appointmentService";

const service = new AppointmentsService();

const AppointmentPopup = () => {
  const [appointmentId, setAppointmentId] = useState(null);
  const [appointment, setAppointment] = useState(null);
  const [message, setMessage] = useState("");

  // Listen for appointmentId from parent or use URL
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get("id");
    if (id) setAppointmentId(parseInt(id));

    const listener = (e) => {
      if (e.data && e.data.inputTarget === "appointmentId") {
        setAppointmentId(parseInt(e.data.value));
      }
    };
    window.addEventListener("message", listener);
    return () => window.removeEventListener("message", listener);
  }, []);

  // Fetch appointment when ID is set
  useEffect(() => {
    if (appointmentId) {
      service.getAppointmentById(appointmentId)
        .then(data => setAppointment(data))
        .catch(err => setMessage(`Error: ${err.message}`));
    }
  }, [appointmentId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAppointment({ ...appointment, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await service.updateAppointment(appointmentId, appointment);
      setMessage("Appointment updated successfully.");
    } catch (err) {
      setMessage(`Update failed: ${err.message}`);
    }
  };

  if (!appointment) return <div>Loading...</div>;

  return (
    <div style={{ padding: "20px", fontFamily: "Arial" }}>
      <h2>Edit Appointment ID: {appointmentId}</h2>
      <form onSubmit={handleSubmit}>
        <label>
          Office ID:
          <input name="officeId" value={appointment.officeId || ""} onChange={handleChange} />
        </label>
        <br />

        <label>
          Doctor ID:
          <input name="doctorId" value={appointment.doctorId || ""} onChange={handleChange} />
        </label>
        <br />

        <label>
          DiagComb ID:
          <input name="diagCombId" value={appointment.diagCombId || ""} onChange={handleChange} />
        </label>
        <br />

        <label>
          Appointment Date:
          <input name="appointmentDate" type="date" value={appointment.appointmentDate || ""} onChange={handleChange} />
        </label>
        <br />

        <label>
          Appointment Time:
          <input name="appointmentTime" type="time" value={appointment.appointmentTime || ""} onChange={handleChange} />
        </label>
        <br />

        <label>
          Type Visit:
          <input name="typeVisit" value={appointment.typeVisit || ""} onChange={handleChange} />
        </label>
        <br />

        <label>
          Notes:
          <textarea name="notes" value={appointment.notes || ""} onChange={handleChange} />
        </label>
        <br />

        <label>
          Conformation:
          <input name="conformation" value={appointment.conformation || ""} onChange={handleChange} />
        </label>
        <br />

        <button type="submit">Update</button>
      </form>

      {message && <p style={{ color: "green" }}>{message}</p>}
    </div>
  );
};

export default AppointmentPopup;
